import {Grey17, Grey6} from "../../theme/styles";

import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import React from "react";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import {Edit, MoreVert} from "@mui/icons-material";
import css_self from "../Navigation/css/NavBar.module.scss";
import EventBus from "../../util/EventBus";
import DeveloperEndpointConfigurationFormApplet from "../../eoec/applet/impl/EndpointManagement/DeveloperEndpointConfigurationFormApplet";
import {withAppContext} from "../../util/withAppContext";

class DeveloperEndpointConfigurationTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("developer-endpoint-configuration-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("developer-endpoint-configuration-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("developer-endpoint-configuration-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("developer-endpoint-configuration-form-applet-save", this.onCancelHandler);
    }

    enterpriseComponentInsertCompleted(ec) {
        super.enterpriseComponentInsertCompleted(ec)

        ec.invalidateChildren();
    }

    enterpriseComponentDeleteCompleted(ec) {
        super.enterpriseComponentDeleteCompleted(ec)

        ec.invalidateChildren();
    };

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Endpoint Configuration") {
            this.setState({renderTarget: "New Endpoint Configuration"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "Edit Endpoint Configuration") {
            return <DeveloperEndpointConfigurationFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Edit" />;
        } else if (this.state.renderTarget === "New Endpoint Configuration") {
            return <DeveloperEndpointConfigurationFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New" />;
        } else if (this.state.renderTarget === "Delete Endpoint Configuration") {
            return <DeveloperEndpointConfigurationFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete" />;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderActionCell = (___, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px", marginRight: "-20px", paddingBottom: "5px", paddingLeft: "4px"}}>
                <IconButton onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit Endpoint Configuration"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Endpoint Configuration</Typography>
                    </MenuItem>
                    <MenuItem divider key={"2"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Delete Endpoint Configuration"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Endpoint Configuration</Typography>
                    </MenuItem>

                </Menu>
            </div>
        )
    }
}

export default withNavigate(withAppContext(withBreakpoint(DeveloperEndpointConfigurationTable)));